import { SUPPORTED_LOCALES } from '@/constants/locales'

export default function (file) {
	let messages = {}
	for (let locale of SUPPORTED_LOCALES) {
		try {
      const msgs = require(`@/lang/${locale}/${file}.json`)
      messages[locale] = msgs
    } catch (error) {
      messages[locale] = {}
    }
	}
	return {
		i18n: {
			messages
		}
	}
}


// WEBPACK FOOTER //
// ./src/mixins/i18n.mixin.js